import { FigmaTypography } from "@libs/zapi-ui/custom";
import { InitialHeader } from "./_InitialHeader";

export function NoClaimsWidget({ analyzeSlot }: { analyzeSlot: React.ReactNode }) {
  return (
    <div className="h-full flex flex-col flex-grow overflow-y-auto" data-testid="claims-root">
      <InitialHeader />
      <div className="h-full flex flex-col p-2 gap-2 items-center justify-center bg-innoveraZinc-100 rounded-b-[8px]">
        <div className="h-full flex flex-col p-1 bg-innoveraZinc-100 rounded-b-[8px]">
          <div className="h-full flex flex-col gap-1 items-center justify-center">
            <FigmaTypography variant="body-3" color="zinc500" className="text-center">
              Extract and verify all factual claims in this memo
            </FigmaTypography>
            <FigmaTypography variant="body-3" color="zinc500" className="text-center max-w-[220px]">
              Identifies all verifiable statements and their sources
            </FigmaTypography>
            {analyzeSlot}
          </div>
        </div>
      </div>
    </div>
  );
}
